import "./modules/base";


//
// Na stránkách kromě našeho vlastního kódu (jehož je i tento skript
// součástí) používáme i kód třetích stran. Kód třetích stran ale typicky
// netvoří klíčovou roli na všech podstranách (Google mapa není na každé
// podstranáce, ani Twisto platba atp.) a přítomnost tohoto kódu by zbytečně
// zpomalovala (zatěžovala) prohlížeč.
//
// Dynamické načítání modulů navíc umožňuje zjednodušit (unifikovat) volání
// různých pro každou podstranu specifických skriptů bez nutnosti znát
// detaily knihoven třetích stran na té konkrétní stránce. Minimalizujeme
// tak roztříštěnost javascriptového kódu napříč celým webem a lépe se nám
// daří veškerý javascriptový kód držet pohromadě na jednom místě.
//
// Každý modul je načtený pouze jednou, tj. není nutné v kódu hlídat,
// kolikrát požadavek na načtení modulu zavoláme.
//


// *************************************************************************
// Moduly k dispozici
// *************************************************************************



//
// Modul pro Twisto
//
// params.key ... veřejný klíč od Twisto
//
// availableModules["twisto"] = function(params) {
// 	var config = {
// 		public_key: params.key,
// 		script: "https://static.twisto.cz/api/v2/twisto.js"
// 	};

// 	console.log("LOADUJU");

// (function(e,g,a){function h(a){return function(){b._.push([a,arguments])}}var f=["check"],b=e||{},c=document.createElement(a);a=document.getElementsByTagName(a)[0];b._=[];for(var d=0;d<f.length;d++)b[f[d]]=h(f[d]);this[g]=b;c.type="text/javascript";c.async=!0;c.src=e.script;a.parentNode.insertBefore(c,a);delete e.script}).call(window,config,"Twisto","script");

// window.Twisto = config;
// console.log(window.Twisto);
// window.Twisto._ = [];
// console.log(window.Twisto);
// window.Twisto.check = function(value) {
// 	return function() {
// 		window.Twisto._.push([a, arguments]);
// 	}
// }
// console.log(window.Twisto);

// var script = document.createElement("script");
// script.async = true;
// script.src = config.script;

// document.body.appendChild(script);
// console.log(window.Twisto);


// (function(e,g,a){
// function h(a){return function(){b._.push([a,arguments])}}
// var f=["check"],
// b=e||{},
// c=document.createElement(a);
// a=document.getElementsByTagName(a)[0];
// b._=[];
// for(var d=0;d<f.length;d++)b[f[d]]=h(f[d]);

// this[g]=b;
// c.type="text/javascript";
// c.async=!0;
// c.src=e.script;
// a.parentNode.insertBefore(c,a);
// delete e.script
// }).call(window, config, "Twisto", "script");


// 		var e = config;
// 		var g = "Twisto";
// 		var a = "script";
// 		function h(a) { return function() { b._.push([a, arguments]) } } var f = ["check"],
// 		b = e || {},
// 		c = document.createElement(a);
// 		a = document.getElementsByTagName(a)[0];
// 		b._ = []; for (var d = 0; d < f.length; d++) b[f[d]] = h(f[d]);
// 		window[g] = b;

// 		console.log(window.Twisto);

// 		c.type = "text/javascript";
// 		c.async = !0;
// 		c.src = e.script;
// 		a.parentNode.insertBefore(c, a);
// 		delete e.script
// }


// *************************************************************************
// Loader
// *************************************************************************

//
// Načítání modulů podle jejich jména a s případnými parametry.
// Funguje obdobně jako např. Google Tag Manager, kdy se načtení nového
// modulu provede skrze zavolání metodu "push". To může být buď obyčejná
// metoda klasického JavaScriptového pole (je inicializováno v @base.latte
// souboru) a nebo po načtení tohoto skriptu jde o metodu třídy ModulesLoader.
//
function ModuleLoader(modules) {
	// Seznam požadovaných modulů.
	this.modules = {};

	// Pokud už některé podstrany si vyžádaly moduly před inicializací této
	// třídy, tak je nyní můžeme už načíst.
	if (modules) {
		for (var i = 0; i < modules.length; ++i) {
			this.push(modules[i]);
		}
	}
}
ModuleLoader.prototype = {
	contructor: ModuleLoader,

	//
	// Proměnná "params" může být buď řetězec jako název modulu, který
	// chceme nahrát. A nebo objekt s parametry modulu.
	//
	push: function(params) {
		if (!params) {
			return;
		}

		// Zkrácený zápis názvu modulu k načtení ve formě řetězce převeďme na objekt,
		// abychom si zjednodušili práci v dalším kódu.
		if (typeof params != "object") {
			params = {
				name: params
			};
		}

		if (params.name in this.modules) {
			// Je-li už daný modul načtený, nemáme co dál dělat.
			return;
		}

		// Z objektu extrahujme jméno modulu a zbude nám objekt s parametry,
		// který pak předáme loaderu.
		var moduleName = params.name;
		delete params.name;

		// Uložíme si modul mezi načtené moduly.
		this.modules[moduleName] = params;

		// A provedeme samotné načtení.
		window.Modules[moduleName].load(params)
	},

};

window.ModuleLoader = new ModuleLoader(window.ModuleLoader);
